import { instances } from '@/services/http';
import type {
  SignUpProspectPostReferredRequestType,
  SignUpProspectPostReferredResponseType,
} from '@magma-app/magma-types/sign-up-prospect';
import { useMutation } from '@tanstack/vue-query';

export const useCreateHelpee = () => {
  return useMutation({
    mutationFn: async (
      payload: SignUpProspectPostReferredRequestType & { turnstileToken?: string }
    ) => {
      const { turnstileToken, ...requestPayload } = payload;
      const response = await instances.main.post(
        '/sign-up-prospect/referred',
        requestPayload,
        {
          ...(turnstileToken && {
            headers: {
              'x-turnstile-token': turnstileToken,
            },
          }),
        }
      );
      return response.data as SignUpProspectPostReferredResponseType;
    },
  });
};
